import React, {useState} from 'react'
import {Collapse} from 'antd'
import ChoosePhotos from './ChoosePhotos'
import ChooseRoomsPriority from './ChooseRoomsPriority'
import BrokerDetails from './BrokerDetails'

const ProvideInput = ({product}) => {
  const inputAssets = product.inputAssets.edges.map(e => e.node)
  const roomsPriority = product.roomsPriority

  let defaultStep = 'photos'
  if (inputAssets.length > 0) defaultStep = 'rooms'
  if (roomsPriority && roomsPriority.length > 0) defaultStep = 'broker'
  const [step, setStep] = useState(defaultStep)

  return (
    <div>
      <Collapse
        accordion
        activeKey={step}
        onChange={setStep}
      >
        <Collapse.Panel
          key="photos"
          header={`Velg 7-15 bilder til produksjon av SoMe.${inputAssets.length > 0 ? ' (Ferdig)' : ''}`}
        >
          <ChoosePhotos
            product={product}
            setStep={setStep}
          />
        </Collapse.Panel>

        <Collapse.Panel
          key="rooms"
          header={`Velg romprioritering${roomsPriority && roomsPriority.length > 0 ? ' (Ferdig)' : ''}`}
          disabled={inputAssets.length === 0}
        >
          <ChooseRoomsPriority
            product={product}
            setStep={setStep}
          />
        </Collapse.Panel>

        <Collapse.Panel
          key="broker"
          header="Meglers info"
          disabled={inputAssets.length === 0 || !roomsPriority || roomsPriority.length === 0}
        >
          <BrokerDetails
            product={product}
          />
        </Collapse.Panel>
      </Collapse>
    </div>
  )
}

export default ProvideInput
